import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
import PrimerHeadlessPaymentMethodPropsIos from './../../_common/_props/PrimerHeadlessPaymentMethodPropsIos.mdx';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Group = makeShortcode("Group");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p>{`This method will return the payment methods that should be displayed based on the current client session data.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`func primerHeadlessUniversalCheckoutDidLoadAvailablePaymentMethods(_ paymentMethods: [PrimerHeadlessUniversalCheckout.PaymentMethod])
`}</code></pre>
    <h4>{`Parameters`}</h4>
    <Group closed summary='Properties' mdxType="Group">
	<PrimerHeadlessPaymentMethodPropsIos mdxType="PrimerHeadlessPaymentMethodPropsIos" />
    </Group>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      